import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { confirmable, createConfirmation } from 'react-confirm';
import { ThemeProvider } from 'styled-components';
import Button from '../button';
import Modal from '../modal';
import theme from '~/theme';
import _ from 'lodash';

const ConfirmModal = ({
						  show,
						  proceed,
						  title,
						  content,
						  cancelText,
						  confirmText,
						  cancelVariant = 'secondary',
						  confirmVariant = 'primary',
						  textField
}) => {

	const [textFieldValue, setTextFieldValue] = useState('');

	return (
		<ThemeProvider theme={theme}>
			<Modal
				isOpen={show}
				contentLabel={title}
				shouldCloseOnOverlayClick={false}
				onRequestClose={() => proceed(false)}
			>
				<Modal.Body>
					<h3>{title}</h3>
					<span>{content}</span>
					{textField && <input
						type="text"
						name="confirmMessage"
						id="confirmMessage"
						onChange={(e) => setTextFieldValue(e.target.value)}
					/>
					}
				</Modal.Body>

				<Modal.Footer>
					<Button
						variant={cancelVariant}
						lighten
						onClick={() => proceed(false)}
						data-testid="confirm-cancel"
					>
						{cancelText}
					</Button>
					<Button
						variant={confirmVariant}
						lighten
						disabled={(textField && _.isEmpty(textFieldValue)) || false}
						onClick={() => proceed( textField ? textFieldValue : true)}
						data-testid="confirm-ok"
					>
						{confirmText}
					</Button>
				</Modal.Footer>
			</Modal>
		</ThemeProvider>
	);

};

ConfirmModal.propTypes = {
	show: PropTypes.bool,
	proceed: PropTypes.func,
	title: PropTypes.string,
	textField: PropTypes.bool,
	content: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.element
	]),
	cancelText: PropTypes.string,
	confirmText: PropTypes.string,
	cancelVariant: PropTypes.oneOf([
		'primary', 'secondary', 'warning', 'danger', 'ghost-primary'
	]),
	confirmVariant: PropTypes.oneOf([
		'primary', 'secondary', 'warning', 'danger', 'ghost-primary'
	])
};

export default createConfirmation(confirmable(ConfirmModal));
